import type { SITE_WORKING_CONDITION_ACQUISITION_MODULATORS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-working-condition-acquisition-modulators-table/site-working-condition-acquisition-modulators-table.fr.ts";

export const SITE_WORKING_CONDITION_ACQUISITION_MODULATORS_TABLE_ENGLISH_LOCALE = {
  headers: {
    acqRate: "Acquisition rate",
    modulatorCsId: "Modulator Cs Id",
    modulatorHwId: "Modulator Hw Id",
    lastConnectionDate: "Last connection date",
    lastPointDate: "Last point date",
    modulationPerformancePercentage: "Modulation performance",
    modulationCount: "Modulations count",
    linkCsId: "Link Cs Id",
    applianceName: "Appliance",
    linkName: "Link",
    modulatorName: "Modulator",
  },
  empty: "No modulator",
} satisfies typeof SITE_WORKING_CONDITION_ACQUISITION_MODULATORS_TABLE_FRENCH_LOCALE;
